import * as React from "react";
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { ImWarning } from "react-icons/im";
import "./../../assets/css/AuthorizedModal.scss";

function AccessExpiredModal(props) {
  const { isOpen } = props || {};
  const [show, setShow] = useState(isOpen ?? false);

  useEffect(() => {
    setShow(isOpen);
  }, [isOpen]);

  const handleClose = () => {
    setShow(false);
  };
  return (
    <>
      <Modal show={show} backdrop="static" centered>
        <Modal.Header>
          <ImWarning size={18} color="red" />
          <Modal.Title>Access Expired</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Access expired. Your current permissions do not allow use of this feature. Please contact your administrator.
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AccessExpiredModal;
